import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { storeCreator } from 'state';
import { ReactQueryDevtools } from 'react-query-devtools';
import { QueryCache, ReactQueryCacheProvider } from 'react-query';
import { Provider as JotaiProvider } from 'jotai';
import { Switch } from 'react-router';
import {
  PrivateMfaLoginRoute,
  PrivateNewPasswordRoute,
  PrivateRoute,
  PublicRoute,
} from 'common/AuthRoute';
import {
  LoginRoute,
  MfaLoginRoute,
  NewPasswordRoute,
  ForgetPasswordRoute,
  ResetPasswordRoute,
} from 'routes';
import { LoginPage } from 'pages/LoginPage';
import { RootRoute } from '@summer/react-kit';
import { AdminRouter } from 'pages';
import { environment } from 'config/environment';
import { NewPasswordPage } from 'pages/NewPassword';
import { ForgetPasswordPage } from 'pages/ForgetPassword';

import { MfaLoginPage } from 'pages/MfaLoginPage';
import { AppIntlProvider } from 'core/intl/AppIntlProvider';
import { HigoDictionaryProvider } from 'core/HigoDictionaryProvider';
import { AntdConfigProvider } from 'core/antd/AntdConfigProvider';
import { CookiesProvider } from 'react-cookie';
import { CookieInfo } from 'common/components/CookieInfo';

export const browserHistory = createBrowserHistory();
export const { store, persistor } = storeCreator(browserHistory);

export const queryCache = new QueryCache({
  defaultConfig: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error) => {
        console.log(error);
        return false;
      },
    },
  },
});

class App extends React.Component {
  public render() {
    return (
      <Provider store={store}>
        <CookiesProvider>
          <PersistGate persistor={persistor}>
            <JotaiProvider>
              <ReactQueryCacheProvider queryCache={queryCache}>
                <AppIntlProvider>
                  <ConnectedRouter history={browserHistory}>
                    <HigoDictionaryProvider>
                      <AntdConfigProvider>
                        <Switch>
                          <PublicRoute
                            path={LoginRoute}
                            component={LoginPage}
                            exact
                          />
                          <PublicRoute
                            path={ForgetPasswordRoute}
                            component={ForgetPasswordPage}
                            exact
                          />
                          <PublicRoute
                            path={ResetPasswordRoute}
                            component={NewPasswordPage}
                            exact
                          />

                          <PrivateMfaLoginRoute
                            path={MfaLoginRoute}
                            component={MfaLoginPage}
                          />

                          <PrivateNewPasswordRoute
                            path={NewPasswordRoute}
                            component={NewPasswordPage}
                          />
                          <PrivateRoute
                            path={RootRoute}
                            component={AdminRouter}
                          />
                        </Switch>
                        <CookieInfo />
                      </AntdConfigProvider>
                    </HigoDictionaryProvider>
                  </ConnectedRouter>
                  {environment.isDevelopment && (
                    <ReactQueryDevtools initialIsOpen />
                  )}
                </AppIntlProvider>
              </ReactQueryCacheProvider>
            </JotaiProvider>
          </PersistGate>
        </CookiesProvider>
      </Provider>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default App;
